import React from 'react'
import './dashboard_social_media_metrics_card.css'
import { getImgSrc } from '../../../../helpers/getImgSrc'
import LeadsBarChart from '../LeadsBarChart'



const DashboardSocialMediaMetricsCard = ({ metrics_data }) => {

    let className=metrics_data?.name?.replaceAll(' ','_').toLowerCase()
    
    return (
        <div className={"paid_social_media_card "+className+'_overview'}>
            <div className="paid_social_media_card_top" style={{backgroundColor:`${metrics_data?.background_color}`}}>
                <div className='paid_social_media_card_top_heading' >
                    <div className='paid_social_media_card_top_heading_logo'  style={{backgroundColor:`${metrics_data?.logo_background_color}`}}>
                        <img src={getImgSrc('reports')} alt=""/>
                    </div>
                    <div className='paid_social_media_card_top_heading_text'>
                        <h3 className=''>{metrics_data?.name}</h3>
                        <span>{metrics_data?.subheading}</span>
                    </div>


                </div>


            </div>

            <div className="paid_social_media_card_bottom">
                <div className='total_social_media_metrics_container'>
                    {metrics_data?.total_metrics?.map((metrics,index) => {
                        return <div key={index} className='total_social_media_metrics_card'>
                            <span>{metrics?.name}</span>
                            <h3> {Number(String(metrics?.value).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")} </h3>
                        </div>
                    })}

    

                </div>
                {/* Facebook card */}
                <div className="paid_social_media_metrics_card_container">
                    {metrics_data?.platform_metrics?.map((data,index) => {
                        return <div key={index} className='paid_social_media_metrics_card'>
                            <div className={`paid_social_media_metrics_card_top  ${data?.platform_name==="instagram" ?'paid_social_instagram':''}`} >
                                <div className={`paid_social_media_metrics_card_top_header ${!(data?.impressions  && data?.clicks) && 'd-flex justify-content-between align-items-center' }`}>
                                    <div className='d-flex align-items-center gap-1'>
                                    {(data?.impressions  && data?.clicks) ?
                                    <div className='paid_social_media_metrics_card_top_header_logo' >
                                        <img src={data?.platform_icon ? getImgSrc(data?.platform_icon) : ''} alt=""  />
                                    </div>:<></>}
                                    <h5>{data?.platform_name}</h5>
                                    </div>
                                    {!(data?.impressions  && data?.clicks) &&
                                    <div className='paid_social_media_metrics_card_top_header_logo'>
                                    <img src={data?.platform_icon ? getImgSrc(data?.platform_icon) : ''} alt=""  />
                                    </div>}
                                 

                                </div>
                            </div>

                            <div className="paid_social_media_metrics_card_bottom">
                                {((data?.impressions!=undefined  && data?.clicks!=undefined) || (data?.reach!=undefined && data?.likes!=undefined)) ?
                                    <div className='records_container'>
                                        {data?.impressions !=undefined &&
                                        <div className='record'>
                                            <span>Impressions </span>
                                            <span> {Number(String(data?.impressions).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")} </span>

                                        </div>}
                                        {data?.spend !=undefined &&
                                        <div className='record'>
                                            {/* <span>Reactions</span>
                                            <span>{data?.reactions}</span> */}
                                            <span>Spend</span>
                                            <span> {Number(String(data?.spend).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>

                                        </div>}
                                        {data?.reach !=undefined  &&
                                        <div className='record'>
                                            <span>Reach</span>
                                            <span> {Number(String(data?.reach).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>

                                        </div>}
                                        {data?.likes !=undefined  &&
                                        <div className='record'>
                                            <span>Likes</span>
                                            <span> {Number(String(data?.likes).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>

                                        </div>}
                                        
                                        {data?.shares !=undefined  &&
                                        <div className='record'>
                                            {/* <span>Reactions</span>
                                            <span>{data?.reactions}</span> */}
                                            <span>Shares</span>
                                            <span> {Number(String(data?.shares).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>

                                        </div>}
                                        {data?.clicks !=undefined &&
                                        <div className='record'>
                                            <span>Clicks</span>
                                            <span>{Number(String(data?.clicks).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</span>

                                        </div>}

                                    </div> : <div className='productive_platform_container'>
                                        <div className='productive_platform_content'>
                                            <div className='productive_platform_content_logo'>
                                                <img src={data?.productive_platform_icon ? getImgSrc(data?.productive_platform_icon) : ''} alt="" />
                                            </div>
                                            <h5>{data?.productive_platform_name}</h5>
                                        </div>
                                        <div className='productive_platform_progress_bar_container'>
                                            <div className="progress">
                                                <div className="progress-bar" role="progressbar" style={{width:data?.percentage+'%'}} aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                
                                            </div>
                                            <span className='float-end'>{data?.percentage}/100</span>

                                        </div>

                                    </div>}

                                    <div>
                                      
                                    </div>

                            </div>


                        </div>
                    })}



                    {/* Instagram Card */}
                    {/* <div className='paid_social_media_metrics_card'>
                                  <div className="paid_social_media_metrics_card_top paid_social_instagram">
                                      <div className='paid_social_media_metrics_card_top_header'>
                                          <div className='paid_social_media_metrics_card_top_header_logo'>
                                              <img src={getImgSrc('instagram')} alt="" />
                                          </div>
                                           <h5>Instagram</h5>
  
                                      </div>
                                  </div>
                                  <div className="paid_social_media_metrics_card_bottom">
                                      <div className='records_container'>
                                          <div className='record'>
                                              <span>Impressions</span>
                                              <span>8745</span>
  
                                          </div>
                                          <div className='record'>
                                              <span>Reactions</span>
                                              <span>342</span>
  
                                          </div>
                                          <div className='record'>
                                              <span>Clicks</span>
                                              <span>156</span>
  
                                          </div>
  
                                      </div>
  
                                  </div>
  
  
                              </div> */}
                    {/* LinkedIn Card */}
                    {/* <div className='paid_social_media_metrics_card'>
                                  <div className="paid_social_media_metrics_card_top">
                                      <div className='paid_social_media_metrics_card_top_header'>
                                          <div className='paid_social_media_metrics_card_top_header_logo'>
                                              <img src={getImgSrc('linkedin')} alt="" />
                                          </div>
                                           <h5>LinkedIn</h5>
  
                                      </div>
                                  </div>
                                  <div className="paid_social_media_metrics_card_bottom">
                                      <div className='records_container'>
                                          <div className='record'>
                                              <span>Impressions</span>
                                              <span>8745</span>
  
                                          </div>
                                          <div className='record'>
                                              <span>Reactions</span>
                                              <span>342</span>
  
                                          </div>
                                          <div className='record'>
                                              <span>Clicks</span>
                                              <span>156</span>
  
                                          </div>
  
                                      </div>
  
                                  </div>
  
  
                              </div> */}


                </div>
                {/* graph_data */}
                <div className='paid_social_media_card_graph_container' >
                    {metrics_data?.graph_data?.map((data_item,index)=>{
                        return <div key={index} className='graph_card'>
                             <p>{data_item?.name}</p>
                              <LeadsBarChart labels={data_item?.labels} legend={true} bar_graph_data={data_item?.data}  />
                        </div>
                        
            
                    })}

                </div>






            </div>

        </div>
    )
}

export default DashboardSocialMediaMetricsCard